<template>
  <div class="user-detail">
    <div class="beard-box">
      <Breadcrumbs :breadcrumbs="breadcrumbs"></Breadcrumbs>
    </div>
    <div class="user-info" v-if="showUser">
      <Myavatar :userName="showUser.realname" width="88px" height="88px" :imgUrl="showUser.user_avatar"></Myavatar>
      <div class="right">
        <span class="name">{{showUser.realname}}</span>
      </div>
    </div>
    <Mine :uid="showUser.uid" :onlyReal="true"></Mine>
  </div>
</template>
<script>
import Breadcrumbs from './breadcrumbs'
import Mine from './mine'
export default {
  props: ['uid', 'breadcrumbs', 'showUser'],
  components: {
    Breadcrumbs,
    Mine
  },
  mounted() {

  },
  data() {
    return {

    }
  }
}
</script>
<style lang="scss" scoped>
.user-detail {
  height: 100%;
  display: flex;
  flex-direction: column;
  /deep/ {
    .my-avatar-txt {
      font-size: 24px !important;
    }
    .mine {
      margin-top: 24px;
      height: 0;
      flex: 1;
    }
    .search-box {
      box-shadow: none;
    }
  }
  .user-info {
    display: flex;
    align-items: center;
    padding: 0 40px;
  }
  .right {
    display: flex;
    flex-direction: column;
    margin-left: 24px;
    .name {
      color: initial;
      font-size: 24px;
    }
    .info {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: rgba(32, 32, 32, 0.6);
      margin-top: 18px;
      i {
        font-size: 14px;
        margin-right: 5px;
      }
      span:first-child {
        margin-right: 50px;
      }
    }
  }
  .beard-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 40px;
    height: 32px;
  }
}
</style>
